import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CategoriesSkeleton: React.FC = () => (
  <ul className="categories-list">
    {[...Array.from({ length: 24 })].map((_item, index: number) => (
      <li key={index}>
        <Skeleton style={{ width: "100%" }} height={30} />
      </li>
    ))}
  </ul>
);

export default CategoriesSkeleton;
